import AH5EventReportor from 'com/didichuxing/tracker/plugin/reportor/AH5EventReportor';
import { ITrackedEvent } from 'com/didichuxing/tracker/event/ITrackedEvent';
import FailedEvent from 'com/didichuxing/tracker/plugin/events/FailedEvent';
import TimeoutEvent from 'com/didichuxing/tracker/plugin/events/TimeoutEvent';
import ReportCallbackUtil from 'com/didichuxing/tracker/plugin/utils/ReportCallbackUtil';
import EncodeHash from 'com/didichuxing/tracker/plugin/utils/EncodeHash';
import GlobalUtil from 'com/didichuxing/tracker/plugin/utils/GlobalUtil';

/**
 * 上报超时默认时间，单位毫秒。
 * @type {number}
 */
const REPORT_TIMEOUT: number = 1500;

export default class PostEventReportor extends AH5EventReportor {

    /**
     * @override
     * @param {ITrackedEvent} event
     * @returns {Promise<ITrackedEvent>}
     */
    protected reportEventImmediately(event: ITrackedEvent): Promise<ITrackedEvent> {
        return new Promise<ITrackedEvent>((resolve: (evt: ITrackedEvent) => void,
                                           reject: (evt: ITrackedEvent) => void): void => {
            const URL = `${GlobalUtil.getProtocol()}${this.getContext().uploadHost}${this.reportPath}`;
            const xhr = new XMLHttpRequest();
            const eventData = event.getData();
            xhr.timeout = this.getContext().timeout || REPORT_TIMEOUT;
            xhr.ontimeout = () => {
                reject(new TimeoutEvent(event.getType(), eventData.attrs || {}, this.getContext()));
            };
            xhr.open('POST', URL + `?e=${event.getType()}`);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
            xhr.setRequestHeader('oid', eventData.omgId || '');
            xhr.setRequestHeader('seq', eventData.appKey || '');
            // 为请求设置为唯一值
            xhr.setRequestHeader(
                'msgid',
                `${eventData.viewportId || ''}-${eventData.sequence || ''}-${eventData.timestamp || ''}`
            );
            xhr.send(EncodeHash.encodeHashUrl(event.serialize()));
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    try {
                        const response = JSON.parse(xhr.responseText);
                        if (response.state && response.state.code !== 200) {
                            if (response.state.code === 500) {
                                this.errorreportedEvents.add(event);
                            }
                            GlobalUtil.dispatchOmgLog(`POST 200 上报错误${event.getType()}_
                            ${response.state.code || 0}_${response.state.msg || ''}`);
                        }
                        ReportCallbackUtil.reportCallback(response);
                        resolve(event);
                    } catch (error) {
                       // 解析返回值失败但是不抛异常
                       console.error(`上报成功后解析失败:${xhr.responseText}`);
                    }
                }
            };
            xhr.onerror = () => {
                if (xhr.status === 500) {
                    this.errorreportedEvents.add(event);
                } else {
                    console.error('POST上报失败onerror' + xhr.status);
                }
                reject(new FailedEvent(new Error('POST Error'), event.getType(),
                    eventData.attrs || {}, this.getContext()));
            };
        });
    }
}
